// Comparison tables used across the site (GEO-friendly structured data)
export const COMPARISON = {
  headers: ["Dimension", "Traditional SEO", "GEO / AI Search Optimization"],
  rows: [
    ["Primary goal", "Rank web pages in blue links", "Get the brand cited & recommended inside AI answers"],
    ["Optimizes for", "Keywords & backlinks", "Entities, facts, structured data & trust"],
    ["Query surface", "Google & Bing SERPs", "ChatGPT, Gemini, Claude, Perplexity, Copilot, AI Overviews"],
    ["Success metric", "Rankings & organic clicks", "Citations, mentions & share of AI voice"],
    ["Content style", "Long pages targeting queries", "Clear, factual, answerable, machine-readable content"],
    ["Authority signal", "Domain authority", "Entity authority & knowledge-graph presence"],
  ],
};

export const ACRONYMS = [
  {
    term: "SEO",
    full: "Search Engine Optimization",
    desc: "Optimizing to rank pages in traditional search results (Google, Bing).",
  },
  {
    term: "AEO",
    full: "Answer Engine Optimization",
    desc: "Optimizing to win featured answers, snippets and voice results.",
  },
  {
    term: "GEO",
    full: "Generative Engine Optimization",
    desc: "Optimizing so generative AI engines discover, trust and cite your brand in synthesized answers.",
  },
  {
    term: "LLMO",
    full: "Large Language Model Optimization",
    desc: "Shaping how LLMs represent and recommend your brand within their responses.",
  },
];
